import { useTranslation } from 'react-i18next';

type CountryCode =
  | 'FR'
  | 'GB'
  | 'US'
  | 'TH'
  | 'SE'
  | 'NL'
  | 'PT'
  | 'JP'
  | 'IE'
  | 'AE'
  | 'AU'
  | 'MX'
  | 'MA';

export const useCountryDescriptions = () => {
  const { t } = useTranslation();

  const countryDescriptions: Record<CountryCode, string> = {
    FR: t(
      'plan_selection.destination_subtitle_FR',
      "Grab an eSIM plan for France from providers including Orange, Lyca Mobile, and Smartroam. All Smartroam plans run on Free and Orange networks—two of France's major networks.",
    ),
    GB: t(
      'plan_selection.destination_subtitle_GB',
      'Stay connected with a trusted eSIM from leading UK networks like EE, Lyca Mobile, and Three. Enjoy fast, reliable coverage with zero roaming charges, just like home—wherever you go.',
    ),
    US: t(
      'plan_selection.destination_subtitle_US',
      'Switch to a Sim Local eSIM for your U.S. trip and experience reliable, high-speed coverage across all 50 states. All Smartroam plans run on the AT&T and Verizon mobile networks.',
    ),
    TH: t(
      'plan_selection.destination_subtitle_TH',
      'Stay connected in Thailand with an eSIM powered by trusted local providers like DTAC. Enjoy fast, reliable coverage without worrying about roaming charges.',
    ),
    SE: t(
      'plan_selection.destination_subtitle_SE',
      'Ditch roaming charges and weak signals when you arrive in Sweden with eSIM providers like Lyca Mobile, and Smartroam which runs on top networks including H3G Sweden and Telia mobile networks.',
    ),
    NL: t(
      'plan_selection.destination_subtitle_NL',
      'Stay connected to top local networks in the Netherlands with eSIM providers like Orange, Lyca Mobile, and Smartroam which runs on the Vodafone mobile network.',
    ),
    PT: t(
      'plan_selection.destination_subtitle_PT',
      'Stay connected to top local networks in Portugal with eSIM providers like Orange, Lyca Mobile, and Smartroam which runs on MEO, NOS, and Vodafone Portugal networks.',
    ),
    JP: t(
      'plan_selection.destination_subtitle_JP',
      "Stay connected in Japan with eSIM plans from local providers such as au by KDDI. Our Smartroam plans connect you to Japan's NTT Docomo network.",
    ),
    IE: t(
      'plan_selection.destination_subtitle_IE',
      'Stay connected with an eSIM and skip the WiFi hunt and roaming bill. Access trusted networks in Ireland including Lyca Mobile, and Smartroam which runs on Three, O2, and Vodafone Ireland networks.',
    ),
    AE: t(
      'plan_selection.destination_subtitle_AE',
      'Enjoy fast, reliable internet at all times in the UAE. Our Smartroam eSIM plans connect you to the DU mobile network, the same reliable network trusted by locals.',
    ),
    AU: t(
      'plan_selection.destination_subtitle_AU',
      "Enjoy reliable, high-speed coverage and all the mobile data you need across all 16 of Australia's states and territories. All Smartroam eSIM plans connect you to the Optus and Telstra mobile networks.",
    ),
    MX: t(
      'plan_selection.destination_subtitle_MX',
      "Stay connected to Mexico's top local networks with our Smartroam eSIM plans. Enjoy up to unlimited data on AT&T, the same reliable network trusted by locals.",
    ),
    MA: t(
      'plan_selection.destination_subtitle_MA',
      'Enjoy fast, reliable internet at all times in Morocco. Our Smartroam eSIM plans connect you to the Medi Telecom mobile network, the same reliable network trusted by locals.',
    ),
  };

  return countryDescriptions;
};
